module.exports = __webpack_public_path__ + "img/ring_r_i_null_null@3x.4c6177e3.png";